import React from "react"
import { PropsWithStyle, StyledComponent } from "@rogue_4/types"
import classNames from "classnames"

import styles from "./index.module.less"

type THealthStatus = "shield" | "health" | "empty"

const Heart: StyledComponent<{
    left: THealthStatus
    right: THealthStatus
    kalts?: boolean
}> = ({ left, right, kalts, className, style }) => {
    return (
        <div
            className={classNames(
                styles.heart,
                kalts && styles.kalts,
                className
            )}
            style={style}
        >
            <div className={classNames(styles.left, styles[left])}></div>
            <div className={classNames(styles.right, styles[right])}></div>
        </div>
    )
}

const HealthBoss = React.forwardRef<
    HTMLDivElement,
    PropsWithStyle<{ health: number; shield: number; kalts?: boolean }>
>(({ className, style, health, shield, kalts }, ref) => {
    return (
        <div
            ref={ref}
            className={classNames(styles.healthBoss, className)}
            style={style}
        >
            {new Array(11)
                .fill(1)
                .map((_, index) =>
                    !kalts ? (
                        <Heart
                            className={classNames(
                                index >= 5 &&
                                    health + shield <= index * 2 &&
                                    styles.hide
                            )}
                            key={index}
                            left={
                                health > index * 2
                                    ? "health"
                                    : health + shield > index * 2
                                      ? "shield"
                                      : "empty"
                            }
                            right={
                                health > index * 2 + 1
                                    ? "health"
                                    : health + shield > index * 2 + 1
                                      ? "shield"
                                      : "empty"
                            }
                        />
                    ) : (
                        <Heart
                            key={index}
                            className={classNames(
                                index < 6 &&
                                    health + shield <= 20 - index * 2 &&
                                    styles.hide
                            )}
                            left={
                                health > 21 - index * 2
                                    ? "health"
                                    : health + shield > 21 - index * 2
                                      ? "shield"
                                      : "empty"
                            }
                            right={
                                health > 20 - index * 2
                                    ? "health"
                                    : health + shield > 20 - index * 2
                                      ? "shield"
                                      : "empty"
                            }
                            kalts
                        />
                    )
                )}
        </div>
    )
})
HealthBoss.displayName = "HealthBoss"

export default HealthBoss
